import type { ReactNode } from 'react';

/** THE FIXED ACTION COLUMN (ported 2026-10-18 from the medrec console's components/list/ActionCell.tsx, its design plan's Lane 1;
 *  DESIGN_SYSTEM 7: "the sentence is never beside a button"). One fixed width, so the column's edge never moves from row to row (the Queue's
 *  action used to size itself per row). Sweet Claims draws its own controls in it (`children`: the typed fact's box and Save, the one fix,
 *  Read & reply, the main client's case), as the medrec console's one-click Approve does; the rest of a row's fixes sit in its "more" panel
 *  (the row's own ›), so there is no More menu here. A row with no action leaves the column empty. */
export function ActionCell({ children, className = 'lp-act' }: { children?: ReactNode; className?: string }) {
  return (
    <td className={className} data-testid="row-actions">
      <span className="lp-slots">{children}</span>
    </td>
  );
}
